import { Grid, Typography,Container, } from '@mui/material'
import styled from '@emotion/styled'

const FooterContainer = styled(Container)`
    position: relative;
    padding-left: 0px !important;
    padding-right: 0px !important;
`
const VideoBK = styled.video`
    object-fit: cover;
    width: 100%;    
    min-height: 100%;
    position: absolute;
    z-index: -1;
`

const FooterGrid = styled(Grid)`
    background-color: #000;
    padding: 0px 30px 0px 30px;
    @media (max-width: 600px){ 
        padding: 0px 30px 30px 30px;
    }
`
const FooterDec = styled(Typography)`
    color:#F2C71B;
    font-size:40px;
    font-family: poppinBI;
    margin-bottom: 20px;
    padding: 10px 0px 0px 30px;
    @media(max-width:1100px) and (min-width: 767px){
        margin-left: 0px;
        font-size:20px;
        padding: 0px 0px 0px 30px;
    }
    @media(max-width:767px){
        margin-bottom: 20px;
        margin-left: 20px;
        font-size:18px;
    }
`
const ImgGrid = styled(Grid)`
    display: flex;
    justify-content: flex-end;
    @media(max-width: 600px){
        justify-content: center;
        margin-top: 20px;
    }
`
const Socialimg = styled.img`
    margin:0px 5px 0px 0px;
    width:100%;
    max-width:40px;
`
const WantedImg = styled.img`
    width: 75%;
    @media(max-width: 600px){
        width:90%;
    }
`
const CopyRights = styled(Typography)`
    color:#fff;
    font-size:15px;
    font-family: poppinR;
    text-align: right;
    padding:5px;
    @media (max-width: 600px){
        text-align: center;
        font-size:13px;
    }
`
const CopyRightGrid = styled(Grid)`
    margin-top: 180px;
    padding:0px 0px 10px 0px;
    @media (min-width: 1440px){
        margin-top: 400px;
    }
`
const SocialDiv = styled.div`
    padding: 0px 0px 0px 30px;
    @media(max-width:767px){
        margin-left: 20px;
    }
`
const DivContainer = styled.div`
    padding: 130px 0px 50px 0px;
    margin-top: -150px;
    width:calc(100% + 8%);
    margin-left:-2%;
    background:url("./assets/Union.png");
    transform: rotate(355deg);
    @media (max-width: 600px){
        padding: 80px 0px 50px 0px;
        background-size: contain;    
        background-repeat: no-repeat;
        width:calc(100% + 20%);
        margin-left:-10%;
    }
`
const FooterLogo = styled.img`
    width:200px;
    @media(max-width: 600px){
        width:100px;
    }
`
const FooterLogoDiv = styled.div`
    @media(max-width: 600px){
        display:flex;
        justify-content: center;
    }
`
export {FooterGrid,FooterDec,FooterContainer,ImgGrid,Socialimg,WantedImg,CopyRights,CopyRightGrid,VideoBK,SocialDiv,DivContainer,FooterLogo
,FooterLogoDiv}
